import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, of } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as OrderActions from './store/actions/orders.actions';
import { Order } from '../models/order';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(
    protected db: AngularFirestore,
    private store: Store<any>,
  ) { }

  dateAsString(date: Date): string {

    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const stringDate = y + '-' + m + '-' + d;
    return stringDate;
  }

  getOrders$(): Observable<any> {

    const startDate = new Date().toDateString();

    // let startDate = new Date();
    // let range = 1;
    // let theDate = this.dateAsString(startDate);
    // var dayOffset = range;
    // var millisecondOffset = dayOffset * 24 * 60 * 60 * 1000;
    // let rangeDate = startDate;
    // rangeDate.setTime(startDate.getTime() + millisecondOffset);
    // let theRangeDate = this.dateAsString(rangeDate);

    // Looks like the date was invalid. Worked on Android though!

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('createDate', '>=', new Date(startDate))
      // .where('createDate', '<=', new Date(theRangeDate))
      // .orderBy('createDate', 'desc')
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  addOrder(e: any): any {

    console.warn("e...............................e", e)

    return this.db.collection('ts__orders').add(e.order)
      .then(() => {
        console.log('this.db.collection(orders).add(e.order) success');

      }).catch((error) => {
        console.error('Error adding new locale document: ', error);
      });
  }

  // addOrder(order: any) {

  //   console.warn("value...............................", order)
  //   // const order = Object.assign(Order);

  //   // order.createDate = new Date();
  //   // order.companyId = value.companyId;
  //   // order.siteId = value.siteId;
  //   // order.bookingId = value.bookingId;
  //   // order.userId = value.userId;
  //   // order.table = value.table;
  //   // order.orderLines = value.orderLines;
  //   // order.status = 'open';
  //   // order.paymentStatus = false;

  //   // let order: Order = {
  //   //   companyId: order.companyId,
  //   //   siteId: order.siteId,
  //   //   createDate: order.createDate,
  //   //   bookingId:order.bookingId,
  //   //   userId: order.userId,
  //   //   table: order.table,
  //   //   orderLines: order.orderLines,
  //   //   status: order.status,
  //   //   paymentStatus: order.paymentStatus
  //   // };

  //   this.store.dispatch(new OrderActions.AddOrder(order));

  // }

  addOrderFirebase$(order: Order): any {
    console.warn('order................................................', order);

    return this.db.collection('ts__orders').add(order);
  }

  updateOrderStatus(order: any, status: any): any {

    const orderRef: AngularFirestoreDocument<Order> = this.db.collection('ts__orders').doc(order.id);

    const orderData: Order = {
      companyId: order.companyId,
      siteId: order.siteId,
      bookingId: order.bookingId,
      createDate: order.createDate,
      table: order.table,
      userId: order.userId,
      orderLines: order.orderLines,
      status,
      paymentStatus: order.paymentStatus
    };

    return orderRef.set(orderData, { merge: true });

  }

  getOrdersByCompanyIdSiteIdBookingId$(companyId: string, siteId: string, bookingId: string): Observable<any> {
    console.log('companyId', companyId);
    console.log('siteId', siteId);
    console.log('bookingId', bookingId);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      .where('bookingId', '==', bookingId)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getOrdersByCompanyIdSiteId$(companyId: string, siteId: string): Observable<any> {
    console.log('companyId', companyId);
    console.log('siteId', siteId);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const theId = a.payload.doc.id;
            return { id: theId, ...data };
          });
        })
      );
  }

  getOrdersByUserId$(userId: string): Observable<any> {

    const startDate = new Date();
    const range = 1;
    const theDate = this.dateAsString(startDate);
    const dayOffset = range;
    const millisecondOffset = dayOffset * 24 * 60 * 60 * 1000;
    const rangeDate = startDate;
    rangeDate.setTime(startDate.getTime() + millisecondOffset);
    const theRangeDate = this.dateAsString(rangeDate);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('userId', '==', userId)
      .where('createDate', '>=', new Date(theDate))
      .where('createDate', '<=', new Date(theRangeDate))
      .orderBy('createDate', 'desc')
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }


  getOrdersByUserAndCustomerIdSiteId$(userId: string, companyId: string, siteId: string): Observable<any> {

    const startDate = new Date();
    const range = 1;
    const theDate = this.dateAsString(startDate);
    const dayOffset = range;
    const millisecondOffset = dayOffset * 24 * 60 * 60 * 1000;
    const rangeDate = startDate;
    rangeDate.setTime(startDate.getTime() + millisecondOffset);
    const theRangeDate = this.dateAsString(rangeDate);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('userId', '==', userId)
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      // .where('createDate', '>=', new Date(theDate))
      // .where('createDate', '<=', new Date(theRangeDate))
      .orderBy('createDate', 'desc')
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  // Hmm not selecting by company and site
  getOrdersToday$(companyId: string, siteId: string): Observable<any> {

    const theDate = new Date();
    const dateToday = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate());
    const dateTomorrow = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate() + 1);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      .where('createDate', '>=', dateToday)
      .where('createDate', '<', dateTomorrow)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  // getOrdersTodayByUser$(companyId: string, siteId: string, userId: string): Observable<any> {

  //   return this.getOrdersToday$(companyId, siteId);

  //   // return of(this.getOrdersToday$(companyId, siteId).pipe(
  //   //   filter((order: any) => order.userId === userId)
  //   // ));


  // }

  getOrdersTodayByUser$(companyId: string, siteId: string, userId: string): Observable<any> {

    const theDate = new Date();
    const dateToday = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate());
    const dateTomorrow = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate() + 1);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      .where('userId', '==', userId)
      .where('createDate', '>=', dateToday)
      .where('createDate', '<', dateTomorrow)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  getOrdersHistoryByUser$(companyId: string, siteId: string, userId: string): Observable<any> {

    const theDate = new Date();
    const dateToday = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate());
    const dateTomorrow = new Date(theDate.getFullYear(), theDate.getMonth(), theDate.getDate() + 1);

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      .where('userId', '==', userId)
      .where('createDate', '<', dateToday)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  getOrdersByCustomerIdSiteIdBookingId$(companyId: string, siteId: string, bookingId: string): Observable<any> {

    const ordersCollection = this.db.collection<any>('ts__orders', ref => ref
      .where('companyId', '==', companyId)
      .where('siteId', '==', siteId)
      .where('bookingId', '==', bookingId)
    );

    return ordersCollection.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            const dt = new Date(a.payload.doc.data().createDate.seconds * 1000);
            return { id, ...data, dt };
          });
        })
      );
  }

  deleteOrdersByIdFirebase$(id: string): any {
    return this.db.collection('ts__orders').doc(id).delete();
  }

  deleteOrder(id: any): void {
    this.store.dispatch(new OrderActions.DeleteOrder(id));
  }

}
